import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconAddSvg } from "./IconAddSvg.mjs";
const IconAdd = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconAddSvg, ...svgProps }) });
export {
  IconAdd
};
